export default "__VITE_ASSET__DrfD6Rwa__"